import { useEffect, useState } from 'react';

const useSessionStorageState = (key, initialValue) => {
    const [value, setValue] = useState(() => {
        const fallbackValue = typeof initialValue === 'function'
            ? initialValue()
            : initialValue;

        try {
            const storedValue = sessionStorage.getItem(key);

            if (storedValue === null) {
                return fallbackValue;
            }

            try {
                return JSON.parse(storedValue);
            } catch (error) {
                return storedValue;
            }
        } catch (error) {
            return fallbackValue;
        }
    });

    useEffect(() => {
        if (value === undefined || value === null || value === '') {
            sessionStorage.removeItem(key);
            return;
        }

        sessionStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);

    return [value, setValue];
};

export default useSessionStorageState;
